const config = {
  apiUrl: "",
  clubInfo: {
    name: 'Wilson Garden Club (R)',
    address: 'No. 35/2, 9th Cross, Wilson Garden, Bangalore – 560027',
    phone: '080-2240-0190',
    email: 'wilsongardenclub1951@gmail.com',
    established: '1951',
    gstin: 'XXXXX',
    pan: 'XXXXX'
  },
  membershipTypes: ['Permanent', 'Temporary', 'Guest'],
  paymentModes: ['Cash', 'Card', 'UPI', 'Net Banking'],
  gameTypes: ['STAKE', 'SYNDICATE'],
  staffTypes: ['Supervisor', 'Dealer', 'Cashier'],
  defaultDenominations: [1, 2, 5, 10, 20, 50, 100, 200, 500, 2000],
  gamesOfInterest: ['Cards','Badminton', 'Table Tennis', 'Chess', 'Carrom', 'Gym', 'Others'],
  subscriptionFee: 200,
  freeSubscriptionAge: 65
};

export default config;
